import { useEffect, useState } from "react";
import { Table, Button, Tooltip } from "antd";
import { YHModal } from "@/components/YHModal";
import { YhBox } from "@/components/YhBox";
import { ColumnsType, TablePaginationConfig } from "antd/es/table";
import { useDictModel } from "../base/dict/dictModel";
import { IItemAndMaterialSearch, commonModuleService, IItemField, IMaterialField } from "./commonModuleService"
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM } from "@/utils/constants";
import { ISearchPage } from "@/types/ScmTypes";
import { IMaintenanceDetail } from "../maintenance/maintenanceType";
import { maintenanceService } from "../maintenance/maintenanceService";
import { transPgToPagination, momentFormat, repairFormatNum } from "@/utils/utils";
import useGlobalModel from "@/model/globalModel";
import YhTootip from "@/components/YhTootip";
interface IRepairHistoryType {
    visible: boolean,
    licensePlate?: string,
    onCancel: () => void
}
enum IRepairHistoryTab {
    Bill = "order",
    Item = "item",
    Material = "material"
}
export const VehicleRepairHistoryModel = ({
    visible,
    licensePlate = "",
    onCancel,
}: IRepairHistoryType) => {
    const { shopAndOrg } = useGlobalModel(({ shopAndOrg }) => [shopAndOrg]);
    const { getTreeNodeName } = useDictModel();
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const totalPgCfg = { pageSize: -1, pageNum: 1 }
    const [searchParam, setSearchParam] = useState<IItemAndMaterialSearch>({})
    const [dataSource, setDataSource] = useState<IMaintenanceDetail[]>([]);
    const [tabFlag, setTabFlag] = useState<IRepairHistoryTab>(IRepairHistoryTab.Bill)
    const [itemSource, setItemSource] = useState<IItemField[]>([]);
    const [materialSource, setMaterialSource] = useState<IMaterialField[]>([]);

    useEffect(() => {
        if (visible) {
            loadBillData(initPgCfg, { licensePlate })
            setSearchParam({ licensePlate })
        }
        return () => {
            setTabFlag(IRepairHistoryTab.Bill)
        }
    }, [visible])

    const loadBillData = async (page?: ISearchPage, searchValue: IItemAndMaterialSearch = searchParam) => {
        let searchParams = {
            ...searchValue,
            ...shopAndOrg,
            status: 'maintenance.settle,maintenance.completed,maintenance-status.final',
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await maintenanceService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    const onBill = () => {
        setTabFlag(IRepairHistoryTab.Bill)
        loadBillData(initPgCfg, { licensePlate })
    }
    const onItem = async () => {
        setTabFlag(IRepairHistoryTab.Item)
        let searchParams = {
            licensePlate,
            ...shopAndOrg,
            ...totalPgCfg,
            status: 'maintenance.settle,maintenance.completed,maintenance-status.final',
        }
        let { retData } = await commonModuleService.recordItem(searchParams);
        setItemSource(retData);
    }
    const onMaterial = async () => {
        setTabFlag(IRepairHistoryTab.Material)
        let searchParams = {
            licensePlate,
            ...shopAndOrg,
            ...totalPgCfg,
            status: 'maintenance.settle,maintenance.completed,maintenance-status.final',
        }
        let { retData } = await commonModuleService.recordMater(searchParams);
        setMaterialSource(retData)
    }
    const columns: ColumnsType<IMaintenanceDetail> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '车辆牌照',
            width: 120,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '客户名称',
            width: 120,
            dataIndex: 'customerName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'maintenanceCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据日期',
            width: 140,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '工单状态',
            width: 120,
            dataIndex: 'status',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '维修类型',
            width: 120,
            dataIndex: 'serviceNatureName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '送修人',
            width: 120,
            dataIndex: 'contact',
        }, {
            title: '维修工',
            width: 120,
            dataIndex: 'technicianNames',
        }, {
            title: '维修工时数',
            width: 120,
            dataIndex: 'workHour',
        }, {
            title: '维修配件数',
            width: 120,
            dataIndex: 'materialNum',
        }, {
            title: '工时费',
            width: 120,
            dataIndex: 'workingHoursAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '配件费',
            width: 120,
            dataIndex: 'materialScienceAmount',
            render: (text) => `￥${repairFormatNum(text)}`
        }, {
            title: '结算方',
            width: 120,
            dataIndex: 'paymentMethodName',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}><p className="ellipsis">{record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}</p></Tooltip>,
        }, {
            title: '车辆里程',
            width: 140,
            dataIndex: 'mileage',
        }, {
            title: '故障描述',
            width: 140,
            dataIndex: 'faultDesc',
        }, {
            title: '处理意见',
            width: 120,
            dataIndex: 'faultResult',
        }, {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        },
    ]
    const itemColUmns: ColumnsType<IItemField> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '车辆牌照',
            width: 120,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'maintenanceCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '项目编码',
            width: 160,
            dataIndex: 'itemCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '项目名称',
            width: 160,
            dataIndex: 'itemName',
            render: (text: any) => <YhTootip text={text} />,

        }, {
            title: '工时数',
            width: 120,
            dataIndex: 'workHour',
        }, {
            title: '工时费',
            width: 120,
            dataIndex: 'itemAmount',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
        }
    ]
    const materialolUmns: ColumnsType<IMaterialField> = [
        {
            title: '序号',
            width: 60,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '车辆牌照',
            width: 120,
            dataIndex: 'licensePlate',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '单据编号',
            width: 120,
            dataIndex: 'maintenanceCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件编码',
            width: 160,
            dataIndex: 'materialCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件名称',
            width: 160,
            dataIndex: 'materialName',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '配件数',
            width: 120,
            dataIndex: 'num',
        }, {
            title: '配件费',
            width: 120,
            dataIndex: 'materialAmount',
        }, {
            title: '备注',
            width: 120,
            dataIndex: 'note',
        }
    ]

    const title = <>
        <Button
            className={`mr-5 ${tabFlag === IRepairHistoryTab.Bill ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={onBill}
        >单据明细</Button >
        <Button
            className={`mr-5 ${tabFlag === IRepairHistoryTab.Item ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={onItem}
        >项目明细</Button >
        <Button
            className={`mr-5 ${tabFlag === IRepairHistoryTab.Material ? "tab-buts-active" : ""}`}
            type="primary"
            shape="round"
            onClick={onMaterial}
        >配件明细</Button >
    </>
    const ItemTable = <Table
        bordered
        style={{ cursor: "pointer" }}
        columns={itemColUmns}
        dataSource={itemSource}
        pagination={false}
        scroll={{ x: 'max-content', y: 650 }}
    />
    const MaterialTable = <Table
        bordered
        style={{ cursor: "pointer" }}
        columns={materialolUmns}
        dataSource={materialSource}
        pagination={false}
        scroll={{ x: 'max-content', y: 650 }}
    />
    const billTable = <Table
        bordered
        style={{ cursor: "pointer" }}
        columns={columns}
        dataSource={dataSource}
        pagination={{
            ...pgCfg,
            position: ["bottomCenter"],
            showTotal: () => `共${pgCfg.total}条`,
            onChange: (pageNum, pageSize) => {
                loadBillData({ pageNum, pageSize }).then();
            }
        }}
        scroll={{ x: 'max-content', y: 650 }}
    />
    const RepairTabsItem = (str: IRepairHistoryTab) => {
        switch (str) {
            case IRepairHistoryTab.Bill:
                return billTable;
            case IRepairHistoryTab.Item:
                return ItemTable;
            case IRepairHistoryTab.Material:
                return MaterialTable;
            default:
                return <></>;
        }
    }
    return <YHModal
        visible={visible}
        onCancel={onCancel}
        title="车辆维修历史"
        width={'70%'}
        bodyHeight={730}
        showFooter={false}
    >
        <YhBox title={title}>
            {RepairTabsItem(tabFlag)}
        </YhBox>

    </YHModal>
}